import React from 'react'
import { Box, Typography } from '@mui/material'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const LeftSide: React.FC = () => {
  const totalcards = [
    {
      heading: "⁠Get paid to shop, dine, and give feedback!",
    },
    {
      heading: "Enjoy flexible work—choose hours that suit you.",
    },
    {
      heading: "No experience? We’ll guide you! Just bring an eye for detail and great writing skills.",
    },
    {
      heading: "Earn extra money doing what you love. Join today and start shopping!",
    },
   
  ];
  const settings = {

    dots: true, // Show dots for navigation
    infinite: true, // Infinite looping
    speed: 500, // Transition speed in milliseconds
    slidesToShow: 1, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    autoplay: true, 
    autoplaySpeed: 1500, // Auto-play interval in milliseconds
    pauseOnHover: true, // Pause auto-play on hover
    customPaging: (i) => <div className="custom-dot"/>,
  };
  return (
    <Box className='custom-bg' width='100%' height='100vh'>
      <Slider {...settings}>
        {totalcards.map((card, index) => (
          <Box height='90vh' className='d-flex align-items-center justify-content-center' key={index}>
            <Box className='text-center px-5'>
            <Typography className="text-white fs-54">Welcome to</Typography>
            <Typography className="text-white fs-54" fontWeight='bold'>{card.heading}</Typography>
            </Box>
          </Box>

        ))}
      </Slider>
    </Box>
  )
}

export default LeftSide
